import { useEffect, useState } from 'react';

import { isMoreOrLessThanCurrent } from 'utils/dates';

import { BroadcastType } from 'graphql/types';

export interface IBroadcastSettingsProps {
  currentBroadcast: BroadcastType | null;
  futureBroadcast: BroadcastType | null;
  recentBroadcast: BroadcastType | null;
}

const initialSettings: IBroadcastSettingsProps = {
  currentBroadcast: null,
  futureBroadcast: null,
  recentBroadcast: null,
};

export const getBroadcastsStatus = (broadcasts: BroadcastType[]) => {
  if (broadcasts && broadcasts.length) {
    const currentBroadcast =
      broadcasts.find(
        (b) =>
          b.published &&
          isMoreOrLessThanCurrent(b.startTime) &&
          isMoreOrLessThanCurrent(b.finishTime, true)
      ) || initialSettings.currentBroadcast;

    const futureBroadcast =
      broadcasts.find(
        (b) => b.published && isMoreOrLessThanCurrent(b.startTime, true)
      ) || initialSettings.futureBroadcast;

    const passedBroadcasts = broadcasts.filter(
      (b) =>
        (b.published && isMoreOrLessThanCurrent(b.finishTime)) ||
        initialSettings.recentBroadcast
    );

    const recentBroadcast =
      (passedBroadcasts && passedBroadcasts[passedBroadcasts.length - 1]) ||
      initialSettings.recentBroadcast;

    return { currentBroadcast, futureBroadcast, recentBroadcast };
  }

  return initialSettings;
};

export const useBroadcastsStatus = (
  broadcasts: BroadcastType[]
): IBroadcastSettingsProps => {
  const [broadcastsSettings, setBroadcastsSettings] = useState(initialSettings);

  useEffect(() => {
    const { currentBroadcast, futureBroadcast, recentBroadcast } =
      getBroadcastsStatus(broadcasts);
    setBroadcastsSettings({
      currentBroadcast,
      futureBroadcast,
      recentBroadcast,
    });
  }, []);

  return broadcastsSettings;
};
